// extracted by mini-css-extract-plugin
export default {"subsectionWrapper":"StatisticsModule_subsectionWrapper__UB5vT","ctaButton":"StatisticsModule_ctaButton__ltTUy"};